<template>
  <CommonPopup
    :title="$t('Common.UpdateReloadTitle')"
    :confirmText="$t('Common.UpdateReloadConfirm')"
    :onConfirm="confirm"
  >
    <p class="text-14 font-[500] leading-20 text-center my-4">
      {{ $t("Common.UpdateReloadContent") }}
    </p>
  </CommonPopup>
</template>

<script setup lang="ts">
import CommonPopup from "@/components/commonPopup/index.vue";
import { isInIframe } from "@/env";
const confirm = () => {
  if (isInIframe) {
    window.parent.postMessage({
      type: 'RELOAD',
      payload: {},
    }, '*')
    console.log('我是在iframe中刷新的页面')
  } else {
    location.reload();
  }
};
</script>

